import { useState, useEffect } from "react";
import useAuth from "../../../Redux/useAuth";
import {
  ButtonSign,
  ContainerModel,
  ContentContainerModel,
  EnteredCode,
  StepsAuthCode,
  TitleModel,
} from "./QRCodeValidationModelStyles.styled";
import { useQRCodeValidation } from "../../../API/QRCode/QRCodeValidation";
import { useLanguageContext } from "../../Languages/Langs/LanguageContext";

interface ValidationQRCodeProps {
  onClose: () => void;
}

export const ValidationQRCode: React.FC<ValidationQRCodeProps> = ({
  onClose,
}) => {
  const { t } = useLanguageContext();
  const { tokenAccount, idUser } = useAuth();
  const { validateQRCodeSignIn, error, isValid } = useQRCodeValidation(
    tokenAccount,
    idUser || null,
  );
  const [checkQRCode, setCheckQRCode] = useState("");

  const filled = !!checkQRCode.trim();

  const checkCode = async (evt: React.FormEvent<HTMLFormElement>) => {
    evt.preventDefault();
    await validateQRCodeSignIn(checkQRCode);
  };

  useEffect(() => {
    if (isValid) {
      // якщо код успішний → закрити модалку після 1 сек
      const t = setTimeout(() => onClose(), 1000);
      return () => clearTimeout(t);
    }
  }, [isValid, onClose]);

  return (
    <ContainerModel>
      <ContentContainerModel>
        <TitleModel>
          {t("privateTraslate.Models.AuthenticationQRCodeTitle")}
        </TitleModel>
        <StepsAuthCode>
          {t("privateTraslate.Models.AuthenticationQRCodeText")}
        </StepsAuthCode>

        <form onSubmit={checkCode}>
          <EnteredCode
            type="text"
            placeholder={t(
              "privateTraslate.Models.AuthenticationQRCodeValidationCode",
            )}
            value={checkQRCode}
            onChange={(e) => setCheckQRCode(e.target.value)}
          />
          {error && !isValid && <span style={{ color: "red" }}>{error}</span>}
          {isValid && (
            <span style={{ color: "green" }}>
              ✅ {t("privateTraslate.Models.AuthenticationQRCodeValidCode")}
            </span>
          )}

          <ButtonSign
            type="submit"
            value={t("privateTraslate.Models.AuthenticationQRCodeButtonFinish")}
            $filled={filled}
            disabled={!filled}
          />
        </form>
      </ContentContainerModel>
    </ContainerModel>
  );
};
